import { render, staticRenderFns } from "./user-choose.vue?vue&type=template&id=557668b4"
import script from "./user-choose.vue?vue&type=script&lang=js"
export * from "./user-choose.vue?vue&type=script&lang=js"
import style0 from "./user-choose.vue?vue&type=style&index=0&id=557668b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports